import React, { Component, PropTypes } from 'react';
import { Row, Col } from 'react-bootstrap';
import './subscribed.scss'

export default class Subscribed extends Component {

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  render () {
    return <Row className="subscribed">
      <Col xs={12}>
        <div>You have been subscribed to this list. You can unsubscribe at anytime through your Profile settings.</div>
      </Col>
    </Row>;
  }

}



// WEBPACK FOOTER //
// ./src/views/subscribed.jsx